import { getCompany } from "../config/companyConfig";
import { StorageKeys, session, local } from "./storage";

export const API_URL = process.env.REACT_APP_API_URL;
export const GETNET_API_URL = process.env.REACT_APP_GETNET_API_URL;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const SSO_LOGIN_URL = process.env.REACT_APP_SSO_LOGIN_URL;
export const SSO_APP_NAME = process.env.REACT_APP_SSO_APP_NAME;

export const getSelectedAlmacenStorage = () =>
  local.get(StorageKeys.SELECTED_ALMACEN) || getCompany().defaultWarehouse;

export const getHeaders = () => {
  const headerText = new Headers();

  const username = session.get(StorageKeys.AUTH_USERNAME);
  const password = session.get(StorageKeys.AUTH_PASSWORD);

  headerText.append("Content-Type", "application/json;charset=UTF-8");
  if (username && password) {
    headerText.append("Authorization", "Basic " + btoa(`${username}:${password}`));
  }
  return headerText;
};
